import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconArrowDownSimple from 'components/icons/iconArrowDownSimple';
const MenuButtonLabel = t0 => {
  const $ = _c(5);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span>{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span><IconArrowDownSimple /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
MenuButtonLabel.propTypes = {
  title: PropTypes.string
};
export default MenuButtonLabel;